export default __webpack_public_path__ + "static/media/markerIcon.94fc70a9.svg";